import { render, staticRenderFns } from "./MyQuotationCommodityConfirmSendUpdate.vue?vue&type=template&id=2cb16052&"
import script from "./MyQuotationCommodityConfirmSendUpdate.vue?vue&type=script&lang=js&"
export * from "./MyQuotationCommodityConfirmSendUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb16052')) {
      api.createRecord('2cb16052', component.options)
    } else {
      api.reload('2cb16052', component.options)
    }
    module.hot.accept("./MyQuotationCommodityConfirmSendUpdate.vue?vue&type=template&id=2cb16052&", function () {
      api.rerender('2cb16052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyQuotation/MyQuotationDetail/MyQuotationCommodity/MyQuotationCommodityConfirmSendUpdate.vue"
export default component.exports